import './Auth.css';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import google from '../../Assets/Images/RegisterPage/social.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  ForgotPasswordAuth } from '../../services/auth.jsx';


function ResetPassword(){

    const navigate=useNavigate();

    const [email,setEmail]=useState();

    const [error,setError]=useState();

    const [isDisabled, setIsDisabled] = useState(false);


    const validateEmail = (email) => {
        
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
              if (!emailRegex.test(email)) {
                setError("Please enter a valid email ID");
                return false;
                
          } else {
               setError('');
               return true;
          }
      };

    async function HandleSubmit(e){
        e.preventDefault()

         if(!validateEmail(email)) return ;

         setIsDisabled(true);
        const forgotPassword=await ForgotPasswordAuth(email);

        if(forgotPassword && forgotPassword.message)
        {
             navigate('/emailsubmitted');
        }
        else
        {
            setError(forgotPassword);
        }
    }  
    return(
        <>
             <div className='logincontainer'>
                    <form className='loginform' onSubmit={(e)=>HandleSubmit(e)}>
                           <h2>Forgot Password</h2>
                           <h3> Please enter your registered email ID</h3>
                           <section className='logininput'>
                           <input type='email' name='email' placeholder='Email' onChange={(e)=>setEmail(e.target.value)}/>
                           </section>
                           <section className='loginbuttons'>
                            <label className='mobileerror' style={{marginBottom:'5px',color:'var(--border-color)'}}>{error}</label>
                                <button className='loginbutton' type='submit' disabled={isDisabled}>SEND</button>
                                <div className='orsection'>
                                    <hr  class="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  class="custom-hr"/>
                                </div>
                            </section>
                    </form>
                    {/* <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} alt='linkedIn' width="38" height="38"/>
                            </section> */}
                            <h4>  Already have an account ? <span  onClick={()=>window.location.href="/login"}>Login here</span></h4>
             </div>
        </>
        );

}

export default ResetPassword;